import { TERMINAL_STATUS_OPTIONS, TerminalStatus } from '../../terminal/terminal.service';

/** `action_type` of the ticket raised when a business orders terminal devices (terminal/order_terminal). */
export const TERMINAL_ORDER_ACTION_TYPE = 'terminal_order';

/** One ordered device, as `assignments/csr_request_details` returns it in `terminal_devices`. */
export interface TerminalTicketDevice {
  tdi_id: number;
  serial_number: string | null;
  carrier: string | null;
  tracking_number: string | null;
  track_link: string | null;
  ship_date: string | null;
  est_delivery_date: string | null;
  delivery_date: string | null;
  condition_on_arrival: string | null;
  status: TerminalStatus;
}

/** `result[0].delivery_address` of a terminal-order ticket — a JSON string or an object. */
export interface TerminalDeliveryAddress {
  street_address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  country?: string;
  device_quantity?: number | string;
}

export function parseDeliveryAddress(raw: unknown): TerminalDeliveryAddress | null {
  if (!raw) {
    return null;
  }
  if (typeof raw !== 'string') {
    return raw as TerminalDeliveryAddress;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export type TerminalShipmentModalMode = 'shipment' | 'delivery';

export const TERMINAL_TICKET_STATUS_OPTIONS = TERMINAL_STATUS_OPTIONS.filter(option => option.value);

export const TERMINAL_CONDITION_OPTIONS = [
  { label: 'Good', value: 'Good' },
  { label: 'Minor damaged', value: 'Damaged' },
  { label: 'DOA', value: 'doa' }
];

/** Statuses that can notify the business by email, and the template each one uses. */
export const TERMINAL_EMAIL_TYPES: Partial<Record<TerminalStatus, string>> = {
  shipped: 'TERMINAL_SHIPPED',
  delivered: 'TERMINAL_DELIVERED',
  reject: 'TERMINAL_REJECTED'
};

export function hasShipmentDetails(device: TerminalTicketDevice): boolean {
  return !!(device.serial_number || device.tracking_number || device.ship_date || device.track_link);
}

/** "2026-09-10" parsed as local midnight; `new Date('2026-09-10')` is UTC and shows the day before in US timezones. */
export function parseLocalDate(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const date = dateOnly ? new Date(+dateOnly[1], +dateOnly[2] - 1, +dateOnly[3]) : new Date(value);
  return isNaN(date.getTime()) ? null : date;
}
